<template>
    <div ref="container"></div>
</template>
<script>
export default {
    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            widgetId: null,
        };
    },

    mounted() {
        this.renderWidget();
    },

    beforeDestroy() {
        if (window.turnstile && this.widgetId !== null) {
            window.turnstile.remove(this.widgetId);
        }
    },

    methods: {
        renderWidget() {
            let tries = 0;
            const tryRender = () => {
                if (window.turnstile && this.$refs.container) {
                    this.widgetId = window.turnstile.render(this.$refs.container, {
                        sitekey: process.env.VUE_APP_TURNSTILE_SITE_KEY,
                        callback: (token) => { this.$emit('input', token); },
                        'expired-callback': () => { this.$emit('input', ''); },
                        'error-callback': () => { this.$emit('input', ''); },
                    });
                } else if (tries < 20) {
                    tries++;
                    setTimeout(tryRender, 250);
                }
            };
            tryRender();
        },
    },
};
</script>
